<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{}"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImgUrl="{ row }">
        <b-avatar
          :src="row.scoreImgUrl ? $osscdn(row.scoreImgUrl) : ''"
        ></b-avatar>
        <span class="ml-3">{{ row.scoreByName }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <b-button
            class="mr-2"
            v-b-tooltip.hover
            :title="$l('INDEX.btn_tips_view') || '查看'"
            @click="showDetail(row.visitScoreCode)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-eye></b-icon-eye>
          </b-button>
          <b-button
            class="mr-2"
            v-b-tooltip.hover
            :title="$l('INDEX.btn_tips_edit') || '编辑'"
            :disabled="row.isOwner !== 'Y'"
            @click="editRating('edit', row.visitScoreCode)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-pencil></b-icon-pencil>
          </b-button>
          <b-button
            v-b-tooltip.hover
            :title="$l('INDEX.btn_tips_del') || '删除'"
            :disabled="row.isOwner !== 'Y'"
            @click="del(row.visitScoreCode)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-trash></b-icon-trash>
          </b-button>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <!--编辑弹框-->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="800px"
    >
      <score-detail :visitScoreCode="curVisitScoreCode"></score-detail>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {
    ScoreDetail: () => import('./scoreDetail.vue'),
  },
  props: {
    visitCode: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      formOption: {
        title: '',
        dialogFormVisible: false,
      },
      tableHeight: 200,
      tableData: [],
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: this.reload,
        },
        zoom: true,
        custom: true,
      },
      tableColumn: [
        {
          field: 'col-opt',
          title: this.$l('INDEX.label_operation') || '操作',
          align: 'center',
          width: 200,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'scoreByName',
          width: 200,
          title: this.$l('label_score_by_name') || '评分人',
          
        },
        {
          field: 'scoreTime',
          width: 180,
          title: this.$l('label_score_time') || '评分时间',
        },
        {
          field: 'score',
          width: 150,
          align: 'center',
          title: this.$l('label_score') || '得分',
        },
        {
          field: 'appraisalBillName',
          minWidth: 300,
          title: this.$l('label_appraisal_bill_name') || '评分模板',
        },
      ],
      curVisitScoreCode: '',
    }
  },
  watch: {
    visitCode: {
      handler() {
        this.loadData()
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  destroyed() {},
  methods: {
    //加载数据
    loadData() {
      this.loading = true
      this.$api
        .getVisitScoreListApi({ visitCode: this.visitCode })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    reload() {
      this.loadData()
    },
    cancel() {
      this.formOption.dialogFormVisible = false
    },
    showDetail(visitScoreCode) {
      this.curVisitScoreCode = visitScoreCode
      this.formOption.title = '评分记录'
      this.formOption.dialogFormVisible = true
    },
    editRating(type, val) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-rating-edit',
        params: {
          pageType: type,
          visitScoreCode: val,
        },
      })
    },
    del(visitScoreCode) {
      let msg = this.$l('INDEX.tips_question_delete') || '是否删除?'

      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api
          .delVisitScoreApi({ visitScoreCode: visitScoreCode })
          .then(() => {
            this.$message.success(
              this.$l('INDEX.tips_operate_ok') || '操作成功!'
            )
            this.loadData()
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.fabric-tree {
  height: 550px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px; /*滚动条宽度*/
  }
}
</style>
